// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import { marked } from 'marked';

function escapeHtml(html) {
  // to keep the <br> tags, we define a placeholder
  const BR_PLACEHOLDER = '__BR_PLACEHOLDER__';
  return (
    html
      // Replace <br> and variants with the placeholder
      .replace(/<br\s*\/?>/gi, BR_PLACEHOLDER)
      // Escape &, < and >
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      // Reintroduce the <br> tags
      .replace(new RegExp(BR_PLACEHOLDER, 'g'), '<br>')
  );
}

// HTML deaktivieren
marked.use({
  renderer: {
    html(html) {
      return escapeHtml(html);
    },
  },
  gfm: true,
  pedantic: false,
});

marked.setOptions({
  breaks: true, // Wichtig für Zeilenumbrüche
  gfm: true,
});

// Stellt sicher, dass Links in neuem Tab geöffnet werden
function addOpenLinksInNewTab(html) {
  return html.replace(/<a(\s[^>]*)?>/gi, (match, attrs = '') => {
    if (/\btarget\s*=/i.test(attrs)) return match;
    return `<a target="_blank" rel="noopener noreferrer"${attrs}>`;
  });
}

/**
 * @param {string} markdown
 * @param {{ openLinksInNewTab?: boolean }} [options]
 */
export function renderMarkdown(markdown, options = {}) {
  let html = marked(markdown);
  if (options.openLinksInNewTab) {
    html = addOpenLinksInNewTab(html);
  }
  return html;
}
